import {FC, useEffect} from 'react';
import { Button, Form, Input, Modal } from "antd";
import {useMediaQuery} from "@uidotdev/usehooks";

export type initialValuesType = {
    level: string
    degree: string
    type: string
    trainings: string
    software: string
    more_title: string
}

export type formValuesType = {
    values: {
        trainings: string
        software: string
    }
}

interface TrainingsModalProps {
    visible: boolean;
    onCancel: () => void;
    onFinish: (values: formValuesType) => void;
    initialValues: initialValuesType;
    isLoading: boolean;
}

export const TrainingsModal: FC<TrainingsModalProps> = ({
                                                                        visible,
                                                                        onCancel,
                                                                        onFinish,
                                                                        initialValues,
                                                                        isLoading
                                                                    }) => {
    const [form] = Form.useForm();
    const isMobile = useMediaQuery("only screen and (max-width : 768px)");

    useEffect(() => {
        form.setFieldsValue(initialValues);
    }, [form, initialValues]);

    const handleOk = () => {
        form.submit();
    };

    return (
        <Modal
            open={visible}
            title="Ihre Weiterbildungen und Spezialkenntnisse"
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Abbrechen
                </Button>,
                <Button key="submit" type="primary" loading={isLoading} onClick={handleOk}>
                    Speichern
                </Button>
            ]}
        >
            <Form
                form={form}
                onFinish={onFinish}
                initialValues={initialValues}
            >
                <Form.Item name="trainings" label="Berufsrelevante Weiterbildungen">
                    <Input size={isMobile? "large" : "middle"}/>
                </Form.Item>
                <Form.Item name="software" label="Kenntnisse in relevanter Software oder Geräten">
                    <Input size={isMobile? "large" : "middle"}/>
                </Form.Item>
            </Form>
        </Modal>
    );
};
